// Banner exibido no detail quando sub está em trial (em_teste) ou expirado — Story 3.9.

import { AlarmClock, CalendarX2, Sparkles } from 'lucide-react';
import { useState } from 'react';
import { daysDiffLocal, formatBR, parseLocalDate, todayLocal } from '@control-center/shared';

import { PillButton } from '../clients/PillButton';
import type { SubscriptionDetail } from '../../lib/subscriptions-api';
import { ExtendTrialModal } from './ExtendTrialModal';

interface TrialBannerProps {
  subscription: SubscriptionDetail;
}

export function TrialBanner({ subscription }: TrialBannerProps): JSX.Element | null {
  const [open, setOpen] = useState(false);

  if (subscription.status !== 'em_teste' && subscription.status !== 'trial_expired') {
    return null;
  }
  if (!subscription.trialEndsAt) return null;

  const trialEndsYmd = subscription.trialEndsAt.slice(0, 10);
  const isExpired = subscription.status === 'trial_expired';
  const daysRemaining = daysDiffLocal(todayLocal(), trialEndsYmd);
  const extendedCount = subscription.trialExtendedCount ?? 0;

  return (
    <>
      {isExpired ? (
        <div className="flex items-start gap-3 rounded-[12px] border border-muted-3/40 bg-panel-2 p-4">
          <CalendarX2 size={18} strokeWidth={1.8} className="mt-0.5 shrink-0 text-muted" />
          <div className="flex-1">
            <div className="text-[13px] font-medium text-ink">Trial expirado</div>
            <p className="mt-1 text-[12px] text-muted">
              O trial terminou em <strong>{formatBR(parseLocalDate(trialEndsYmd))}</strong>. O
              cliente está no grace period — converta manualmente (cobrança avulsa) ou aguarde o
              cancelamento automático em até 7 dias.
            </p>
          </div>
        </div>
      ) : (
        <div className="flex items-start gap-3 rounded-[12px] border border-warn/40 bg-warn/5 p-4">
          <AlarmClock size={18} strokeWidth={1.8} className="mt-0.5 shrink-0 text-warn" />
          <div className="flex-1">
            <div className="text-[13px] font-medium text-ink">Em trial</div>
            <p className="mt-1 text-[12px] text-muted">
              Trial vigente até <strong>{formatBR(parseLocalDate(trialEndsYmd))}</strong> (
              {daysRemaining} {daysRemaining === 1 ? 'dia restante' : 'dias restantes'}).
              {extendedCount > 0 && (
                <span className="ml-1">
                  Estendido <strong>{extendedCount}x</strong>.
                </span>
              )}
            </p>
          </div>
          <PillButton
            type="button"
            onClick={() => setOpen(true)}
            icon={<Sparkles size={12} strokeWidth={2} />}
          >
            Estender trial
          </PillButton>
        </div>
      )}

      <ExtendTrialModal subscription={subscription} open={open} onOpenChange={setOpen} />
    </>
  );
}
